module.exports = __webpack_public_path__ + "static/media/Redux.c8f44df3.png";